import type { StageHighlight } from '../../../features/jamcam-stage/types';
import type { NoteName } from '../../../utils/musicTheory';
import {
  getBluesBoxHighlights,
  getBluesDisplayName,
  getDiatonicBoxHighlights,
  getDiatonicDisplayName,
  getDisplayScaleName,
  getPentatonicBoxHighlights,
  type PentatonicFlavor,
} from '../../../utils/trainingModules';

export type ScaleKind = 'pentatonic' | 'blues' | 'diatonic';

export interface ScaleKindConfig {
  label: string;
  totalPositions: number;
  /** The one Learn module that walks every position of this scale. */
  moduleId: 'major-pentatonic-scale' | 'blues-scale-all' | 'diatonic-scale-all';
  displayName: (flavor: PentatonicFlavor) => string;
  /** `position` is 1-based. */
  getHighlights: (
    root: NoteName,
    position: number,
    flavor: PentatonicFlavor
  ) => StageHighlight[];
  fingeringTip?: string;
}

export const SCALE_KINDS: Record<ScaleKind, ScaleKindConfig> = {
  pentatonic: {
    label: 'Pentatonic',
    totalPositions: 5,
    moduleId: 'major-pentatonic-scale',
    displayName: getDisplayScaleName,
    getHighlights: (root, position, flavor) =>
      getPentatonicBoxHighlights(root, flavor, position - 1),
    fingeringTip: 'On 2-fret stretches use 1-3; on 3-fret stretches use 1-4.',
  },
  blues: {
    label: 'Blues',
    totalPositions: 5,
    moduleId: 'blues-scale-all',
    displayName: getBluesDisplayName,
    getHighlights: (root, position, flavor) =>
      getBluesBoxHighlights(root, position - 1, flavor),
  },
  diatonic: {
    label: 'Diatonic',
    totalPositions: 7,
    moduleId: 'diatonic-scale-all',
    displayName: getDiatonicDisplayName,
    getHighlights: getDiatonicBoxHighlights,
  },
};
